export const LISTING_STATE_DRAFT = 'draft';
export const LISTING_STATE_PENDING_APPROVAL = 'pendingApproval';
export const LISTING_STATE_PUBLISHED = 'published';
export const LISTING_STATE_CLOSED = 'closed';
export const SEARCH_SORT_NEAREST = 'nearest';
export const SEARCH_SORT_RELEVANCE = 'relevance';
